export default [
  {
    text: 'Кооператив',
    value: 'cooperative',
  },
  {
    text: 'Собственность',
    value: 'ownership',
  },
  {
    text: 'По доверенности',
    value: 'byProxy',
  },
];
